module.exports = __webpack_public_path__ + "static/media/illustration_vorot.16fb10c1.png";